import { ExtendableError } from 'ts-error';

export class SystemMaintenanceException extends ExtendableError { }
